"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformKeys = exports.STYLE_SCOPES = exports.DEFAULT_CONTAINER_NAME = exports.INTERNAL_FLAGS = exports.INTERNAL_SET = exports.INTERNAL_RESET = void 0;
exports.INTERNAL_RESET = Symbol();
exports.INTERNAL_SET = Symbol();
exports.INTERNAL_FLAGS = Symbol();
exports.DEFAULT_CONTAINER_NAME = "@__";
exports.STYLE_SCOPES = {
    GLOBAL: 0,
    CONTEXT: 1,
    SELF: 2,
};
exports.transformKeys = new Set([
    "perspective",
    "translateX",
    "translateY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "skewX",
    "skewY",
]);
//# sourceMappingURL=shared.js.map